import {GRID_CUSTOM_COLUMN_TYPES} from "../GridCustomColumnTypes";

// noinspection JSUnusedGlobalSymbols -- imported via d.ts
/**
 * Creates a row picker column with the specified configurations for use in a grid.
 *
 * This function does the minimum necessary to set up the custom column, the actual
 * initialization and grid setup is done in setup-row-selection.js, during grid creation.
 *
 * @param {string} idField - The field used as a unique identifier for each row.
 * @param {string} headerName - The header text for the column.
 * @param {string} rowPickerName - The name assigned to the row picker.
 * @param {import('ag-grid-community/dist/lib/entities/colDef').ColDef} [columnDef] - Optional column definition to customize the column's behavior and appearance.
 * @return {Record<string, any>} The constructed configuration object for the row picker column.
 */
function createRowPickerColumnDef(
	idField,
	headerName = 'Picker',
	rowPickerName = 'row-picker',
	columnDef = {},
) {
	const finalColumnDefs = {
		// Set basic col def fields
		field: idField,
		headerName, // Will be overriden by custom header component anyway

		minWidth: 80,
		maxWidth: 80,

		cellClass: 'fill-space',

		// Override properties with any custom ones
		...columnDef,
	};

	// Add custom properties
	finalColumnDefs._customType = GRID_CUSTOM_COLUMN_TYPES.ROW_PICKER;
	finalColumnDefs._rowPickerIdField = idField;
	finalColumnDefs._rowPickerName = rowPickerName;

	return finalColumnDefs;

	/** Methods */


}

export {createRowPickerColumnDef};
